function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { Emitter } from '@bydesign-ui/hooks';
import { getElementScroll } from '@bydesign-ui/hooks';
export var Anchor = function (_Emitter) {
  _inherits(Anchor, _Emitter);

  var _super = _createSuper(Anchor);

  function Anchor() {
    var _this;

    _classCallCheck(this, Anchor);

    _this = _super.apply(this, arguments);
    _this.itemMap = {};
    _this.scrolling = false;
    _this.duration = 300;
    _this.targetOffset = 0;
    _this.activeId = '';
    _this.activeDot = false;
    _this.hashLink = true;
    return _this;
  }

  _createClass(Anchor, [{
    key: "updateOptions",
    value: function updateOptions(options) {
      var getContainer = options.getContainer,
          _options$duration = options.duration,
          duration = _options$duration === void 0 ? 300 : _options$duration,
          _options$targetOffset = options.targetOffset,
          targetOffset = _options$targetOffset === void 0 ? 0 : _options$targetOffset,
          _options$activeDot = options.activeDot,
          activeDot = _options$activeDot === void 0 ? false : _options$activeDot,
          _options$hashLink = options.hashLink,
          hashLink = _options$hashLink === void 0 ? true : _options$hashLink;
      this.duration = duration;
      this.targetOffset = targetOffset;
      this.activeDot = activeDot;
      this.hashLink = hashLink;

      if (getContainer) {
        this.getContainer = getContainer;
      }
    }
  }, {
    key: "getContainer",
    value: function getContainer() {
      return typeof window !== 'undefined' ? document.documentElement : null;
    }
  }, {
    key: "getTargetOffset",
    value: function getTargetOffset() {
      return this.targetOffset;
    }
  }, {
    key: "setScrolling",
    value: function setScrolling(scrolling) {
      this.scrolling = scrolling;
    }
  }, {
    key: "getActiveDot",
    value: function getActiveDot() {
      return this.activeDot;
    }
  }, {
    key: "getScrolling",
    value: function getScrolling() {
      return this.scrolling;
    }
  }, {
    key: "getActiveId",
    value: function getActiveId() {
      return this.activeId;
    }
  }, {
    key: "getHashLink",
    value: function getHashLink() {
      return this.hashLink;
    }
  }, {
    key: "updateAllItemOffsetTop",
    value: function updateAllItemOffsetTop() {
      var _this2 = this;

      var excludeId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      Object.keys(this.itemMap).forEach(function (id) {
        if (id === excludeId) {
          return;
        }

        _this2.itemMap[id].updateOffsetTop(true);
      });
    }
  }, {
    key: "updateScrollTop",
    value: function updateScrollTop() {
      var _this3 = this;

      var container = this.getContainer();

      if (!container) {
        return;
      }

      var scrollTop = getElementScroll(container).scrollTop;
      var items = Object.values(this.itemMap).filter(function (item) {
        return ~~item.getOffsetTop() - _this3.targetOffset <= scrollTop;
      });

      if (!items.length) {
        return;
      }

      var activeItem = items.reduce(function (item, nextItem) {
        return item.getOffsetTop() < nextItem.getOffsetTop() ? nextItem : item;
      }, items[0]);
      this.setActiveItem(activeItem.getId());
    }
  }, {
    key: "setActiveItem",
    value: function setActiveItem(id) {
      this.activeId = id;
      this.emit('active-item', id);
    }
  }, {
    key: "registerAnchorItem",
    value: function registerAnchorItem(item) {
      this.itemMap[item.getId()] = item;
    }
  }, {
    key: "unregisterAnchorItem",
    value: function unregisterAnchorItem(item) {
      var itemId = item.getId();

      if (!this.itemMap[itemId]) {
        return;
      }

      delete this.itemMap[itemId];
    }
  }, {
    key: "hasItemId",
    value: function hasItemId(itemId) {
      return typeof this.itemMap[itemId] !== 'undefined';
    }
  }]);

  return Anchor;
}(Emitter);